<template>
  <modal :show="show" showLarge>
    <div slot="modalHeader">
      <modal-header :closeModal="close">Create Association</modal-header>
    </div>
    <spinner-icon v-if="loading" />
    <steps :options="stepOptions" :active="step" />
    <div v-if="showError" class="text-danger center">
      {{ errorText }}
    </div>
    <div v-if="step === 1">
      <form-group>
        <field name="Creative Name" v-model="name"/>
      </form-group>
      <creative-table v-if="creative" :subHeading="`Please select the fields for users to be able to edit.`" :tableData="getCreativeFields" v-model="creative.fields" @onToggleParentCheckboxes="updateCheckboxData" :type="getCreativeType" />
    </div>
    <div v-if="step === 2">
      <heading type="h4">
        <small>Please select users to receive this creative. Additional users can be added later.</small>
      </heading>
      <label>Global Users</label>
      <list v-model="userss" :data="getUsers()" :hashId="false" :currentIds="userss" />
      <label>Local Users</label>
      <list v-model="localUsers" :data="getLocalUsers()" :hashId="false" :currentIds="this.localUsers" />
    </div>
    <div v-if="step === 3">
      <form-group>
        <label class="userList__label">
          <input class="userList__input" :name="need_download_approval" type="checkbox" id="download_approval_checkbox" v-model="need_download_approval" :value="need_download_approval" :checked="need_download_approval" @change="need_download_approval">
          Assigned users must request global approvals before downloading.
        </label>
      </form-group>
    </div>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="confirm" :confirmText="(step === 3) ? 'Complete' : 'Next'" :back="back" :showBack="step !== 1" :hideCancelText="step !== 1" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import CreativeTable from '@/components/CreativeTable/creative-table'
import Steps from '@/components/Steps/steps'
import List from '@/components/List/list'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {userMixin} from '@/mixins/userMixin'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import Heading from '@/components/Heading/heading'
import {find, propEq} from 'ramda'

export default {
  name: 'modal_creative_associate',
  mixins: [modalMixin, campaignMixin, creativeMixin, notificationMixin, userMixin],
  components: {
    Checkbox,
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    Heading,
    FormGroup,
    Field,
    CreativeTable,
    Steps,
    List,
    SpinnerIcon
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({
    step: 1,
    name: '',
    need_download_approval: false,
    editable_fields: [],
    userss: [],
    localUsers: [],
    showError: false,
    errorText: 'Assigned User cannot be empty'
  }),
  created () {},
  computed: {
    creative () {
      if (this.creatives) {
        const creative = find(propEq('hash_id', this.confirmId), this.creatives)
        if (creative) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.name = creative.name
          return creative
        }
      }
    },
    getCreativeFields () {
      if (this.creative) {
        return this.creative.fields
      }
    },
    getCreativeType () {
      if (this.creative) {
        return this.creative.type
      }
    },
    stepOptions () {
      let options = [
        'Edit Fields',
        'Assign Users',
        'Approvals'
      ]
      return options
    }
  },
  methods: {
    confirm () {
      if (!this.creative) {
        return
      }
      this.showError = false
      if (this.step === 1) {
        this.step = 2
        return
      }
      if (this.step === 2) {
        if (!this.users.length && !this.localUsers.length) {
          this.showError = true
          return
        }
        this.step = 3
        return
      }

      this.creative.fields.forEach((field) => {
        if (field.is_editable) {
          this.editable_fields.push(field.id)
        }
      })

      let users = this.users
      users = users.concat(this.localUsers)

      let payload = {
        'hash_id': this.creative.hash_id,
        'name': this.name,
        'editable_fields': this.editable_fields,
        'users': users,
        'need_download_approval': this.need_download_approval
      }

      this.startLoading()
      this.associateCreative(payload).then(response => {
        this.getCreatives(this.$route.params.id).then(() => {
          this.emptyForm()
          this.addNotification('success', response.reason)
          this.finishLoading()
        })
      }, error => {
        this.addNotification('eerror', error)
        this.finishLoading()
      })
      this.close()
    },
    back () {
      this.showError = false
      this.step -= 1
    },
    emptyForm () {
      this.step = 1
      this.userss = []
      this.editable_fields = []
      this.need_download_approval = false
    },
    getUsers () {
      return this.campaign.client.associatedUsers.filter((user) => user.role !== 6)
    },
    getLocalUsers () {
      return this.campaign.client.associatedUsers.filter((user) => user.role === 6)
    }
  }
}
</script>

<style lang="scss">
.center {
  display: flex;
  margin: auto;
  width: 50%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-creative-associate.vue